import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, HostListener, Input, ViewChild } from '@angular/core';
import { SupplierQuality } from 'src/app/models/supplierQuality.model';
import { environment } from 'src/environments/environment';
import { SupplierQualityProduct } from 'src/app/models/supplierQualityProduct.model';
import { Role } from 'src/app/models/role.model';

@Component({
  selector: 'app-supplier-quality-products-list',
  templateUrl: './supplier-quality-products-list.component.html',
  styleUrl: './supplier-quality-products-list.component.less'
})
export class SupplierQualityProductsListComponent {
  apiUrl: string =  environment.API_URL;
  
  @Input() roleAuth!: Role;
  @Input() selectedSupplier: SupplierQuality | null = null;

  // PRODUCTS
  productInput = "";
  productToRemove: SupplierQualityProduct | null = null;

  @HostListener('window:keydown.escape') escapeEvent() { this.closePopup(); }
  @ViewChild('addProductInput') addProductInput!: ElementRef;

  constructor(private httpClient: HttpClient) {}

  isAlreadySupplierQualityProduct(productName: string): boolean {
    if ((this.selectedSupplier == null || this.selectedSupplier.supplierQualityProducts == null || this.selectedSupplier.supplierQualityProducts.length === 0)) { return false; }

    return this.selectedSupplier.supplierQualityProducts.find(x => x.productName === productName) != null;
  }

  addProduct() {
    this.productInput = this.productInput.trim();
    if (this.selectedSupplier == null || this.productInput === "") { return; }

    // Don't add if already in the list
    if (this.isAlreadySupplierQualityProduct(this.productInput)) { return; }

    const product = new SupplierQualityProduct();
    product.supplierQualityId = this.selectedSupplier.id;
    product.productName = this.productInput;

    this.httpClient.post<SupplierQualityProduct>(`${this.apiUrl}SupplierQuality/SupplierQualityProduct`, product).subscribe(
      {
        next: (res) => {
          this.selectedSupplier?.supplierQualityProducts?.push(res);
          this.productInput = "";
        },
        error: (e) => {
          console.error(e);
        }
      }
    );
  }

  openRemoveProductPopup(product: SupplierQualityProduct) {
    this.productToRemove = product;
  }

  removeProduct() {
    if(this.productToRemove == null || this.selectedSupplier == null) { return; }

    this.httpClient.delete(`${this.apiUrl}SupplierQuality/SupplierQualityProduct/${this.productToRemove.id}`).subscribe(
      {
        next: () => {
          this.selectedSupplier?.supplierQualityProducts?.splice(this.selectedSupplier?.supplierQualityProducts?.findIndex(x => this.productToRemove != null && this.productToRemove.id === x.id), 1);
          this.closePopup();
        },
        error: (e) => {
          console.error(e);
        }
      }
    );
  }

  closePopup() {
    this.productToRemove = null;
  }
}
